"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
document.addEventListener("DOMContentLoaded", function () {
  var modalOverlay = document.querySelector(".jsBgOverlay");
  var modal = document.querySelector(".omd-table-block-modal");
  if (modal) {
    var tableModalContent = modal.querySelector(".omd-table-block-content-container");
    var notificateByClick = function notificateByClick(e) {
      if (e.target.closest(".omd-table-block th .omd-table-block-info-icon")) {
        var currentIcon = e.target.closest(".omd-table-block th .omd-table-block-info-icon");
        modalOverlay.classList.add("profile-tile-opened");
        modal.classList.add("active");
        if (currentIcon.nextElementSibling) {
          tableModalContent.innerHTML = currentIcon.nextElementSibling.innerHTML;
        }
      }
    };
    document.addEventListener("keydown", function (e) {
      if (modalOverlay && e.key === "Escape") {
        if (modal) {
          modal.classList.remove("active");
          modalOverlay.classList.remove("profile-tile-opened");
        }
      }
    });
    document.addEventListener("click", function (e) {
      if (modalOverlay && (e.target === modalOverlay || e.target.closest(".omd-table-block-modal-close-btn"))) {
        if (modal) {
          modal.classList.remove("active");
          modalOverlay.classList.remove("profile-tile-opened");
        }
      }
    });
    document.addEventListener("click", notificateByClick);
  }
  function customTableAdopt() {
    var tableFirstRows = document.querySelectorAll(".omd-table-block-first-row");
    var tableSpecFirstRows = document.querySelectorAll(".emr-certified-table-block--specification .omd-table-block-first-row");
    var tableSpecs = document.querySelectorAll(".emr-certified-table-block--specification .omd-table-block");
    if (tableFirstRows.length) {
      _toConsumableArray(tableFirstRows).forEach(function (item) {
        var tableBlock = item.nextElementSibling.querySelector(".omd-table-block");
        if (tableBlock) {
          var th = item.nextElementSibling.querySelector("th");
          var thFstRows = item.querySelectorAll("th");
          var trs = item.nextElementSibling.querySelectorAll("tr");
          var tdFstRows = item.querySelectorAll("tr:not(:first-child):not([data-section])");
          tdFstRows.forEach(function (item, index) {
            trs.forEach(function (tr, idx) {
              if (index === idx - 1) {
                if (item.offsetHeight >= tr.offsetHeight) {
                  tr.style.height = "".concat(item.offsetHeight, "px");
                } else {
                  item.style.height = "".concat(tr.offsetHeight, "px");
                }
              }
            });
          });
        }
      });
    }
  }
  customTableAdopt();
  customTableAdopt();
  var specTableAdopt = function specTableAdopt() {
    var tBlockFirstRow = document.querySelector(".omd-table-block-first-row");
    var tBlock = document.querySelector(".omd-table-block:not(.omd-table-block-first-row)");
    var tBlockFstRowFstTr = tBlockFirstRow.querySelector("tr");
    var tBlockFstRow = tBlock.querySelector("tr");
    tBlockFstRowFstTr.style.height = "".concat(tBlockFstRow.offsetHeight - 0.5, "px");
    var tBlockFirstRowTitles = tBlockFirstRow.querySelectorAll("[data-title]");
    tBlockFirstRowTitles.forEach(function (item) {
      var trs = tBlock.querySelectorAll("[data-prim='".concat(item.dataset.title, "']"));
      var sumHeight = _toConsumableArray(trs).reduce(function (acc, item) {
        return acc += Math.ceil(item.offsetHeight);
      }, 0);
      item.style.height = "".concat(sumHeight, "px");
    });
  };
  (function specificationTable() {
    var specTableContainer = document.querySelector(".emr-certified-table-block--specification");
    var noResults = document.querySelector(".omd-table-no-results");
    if (specTableContainer) {
      var adoptSectionHeight = function adoptSectionHeight(specTable, specTableFstRow) {
        var fstRowSections = specTableFstRow.querySelectorAll("[data-section]");
        var tableSections = specTable.querySelectorAll("[data-section]");
        if (fstRowSections && tableSections) {
          _toConsumableArray(fstRowSections).forEach(function (rowSection) {
            _toConsumableArray(tableSections).forEach(function (section) {
              if (rowSection.offsetHeight >= section.offsetHeight) {
                section.style.height = "".concat(rowSection.offsetHeight, "px");
              } else {
                rowSection.style.height = "".concat(section.offsetHeight, "px");
              }
            });
          });
        }
      };
      var initSelectFunctionality = function initSelectFunctionality(specTable, specTableFstRow, specTableTrs, specTableFstRowTrs, selects) {
        specTableAdopt();
        function onSelect() {
          handleSelect(specTable, specTableFstRow, specTableTrs, specTableFstRowTrs, selects);
          adoptSectionHeight(specTable, specTableFstRow);
        }
        var primSelect = document.querySelector(".omd-prim-select");
        var secSelect = document.querySelector(".omd-sec-select");
        var terSelect = document.querySelector(".omd-ter-select");
        if (primSelect && secSelect && terSelect) {
          primSelect.addEventListener("change", onSelect);
          secSelect.addEventListener("change", onSelect);
          terSelect.addEventListener("change", onSelect);
        }
        window.addEventListener("resize", function () {
          specTableAdopt();
        });
        document.addEventListener("click", function (e) {
          if (e.target.closest(".dynamic-select-clear-all")) {
            primSelect.value = "All";
            secSelect.value = "All";
            terSelect.value = "All";
            handleSelect(specTable, specTableFstRow, specTableTrs, specTableFstRowTrs, selects);
            adoptSectionHeight(specTable, specTableFstRow);
          }
        });
      };
      var specTableFstRow = specTableContainer.querySelector(".omd-table-block-first-row");
      var specTable = specTableContainer.querySelector(".omd-table-block:not(.omd-table-block-first-row)");
      var specTableTrs = specTable.querySelectorAll("tr[data-prim]");
      var specTableFstRowTrs = specTableFstRow.querySelectorAll("tr[data-title]");
      var selects = document.querySelectorAll("select");
      var primSelect = document.querySelector(".omd-prim-select");
      var secSelect = document.querySelector(".omd-sec-select");
      var terSelect = document.querySelector(".omd-ter-select");
      var tableSections = document.querySelectorAll("[data-section]");
      var checkIntersection = function checkIntersection(specTable, specTableFstRow, specTableTrs) {
        var intersection = _toConsumableArray(specTableTrs).filter(function (item) {
          return item.dataset.prim && item.dataset.sec && item.dataset.ter && (item.dataset.prim === primSelect.value || primSelect.value === "All") && (item.dataset.sec === secSelect.value || secSelect.value === "All") && (item.dataset.ter === terSelect.value || terSelect.value === "All");
        });
        if (!intersection.length) {
          specTable.classList.add("hidden");
          specTableFstRow.classList.add("hidden");
          noResults.classList.add("active");
        } else {
          specTable.classList.remove("hidden");
          specTableFstRow.classList.remove("hidden");
          noResults.classList.remove("active");
        }
      };
      var handleSelect = function handleSelect(specTable, specTableFstRow, specTableTrs, specTableFstRowTrs, selects) {
        checkIntersection(specTable, specTableFstRow, specTableTrs);
        var chosenSelects = _toConsumableArray(selects).filter(function (select) {
          return select.value !== "All";
        });
        if (chosenSelects.length === 0) {
          specTableTrs.forEach(function (item) {
            item.classList.remove("hidden");
          });
        }
        var selectIds = chosenSelects.map(function (item) {
          return [item.parentNode.parentNode.id, item.value];
        });
        var selectIdsObj = Object.fromEntries(selectIds);
        specTableTrs.forEach(function (item) {
          item.classList.add("hidden");
          if (chosenSelects.length === 0) {
            item.classList.remove("hidden");
          }
          if (chosenSelects.length === 1) {
            if (selectIdsObj.prim === item.dataset.prim || selectIdsObj.ter === item.dataset.ter || selectIdsObj.sec === item.dataset.sec) {
              item.classList.remove("hidden");
            }
          }
          if (chosenSelects.length === 2) {
            if (selectIdsObj.prim === item.dataset.prim && selectIdsObj.ter === item.dataset.ter || selectIdsObj.prim === item.dataset.prim && selectIdsObj.sec === item.dataset.sec || selectIdsObj.sec === item.dataset.sec && selectIdsObj.ter === item.dataset.ter) {
              item.classList.remove("hidden");
              specTableFstRowTrs.forEach(function (item) {
                item.classList.add("hidden");
                if (item.dataset.prim === (selectIdsObj === null || selectIdsObj === void 0 ? void 0 : selectIdsObj.prim)) {
                  item.classList.remove("hidden");
                }
              });
            }
          }
          if (chosenSelects.length === 3) {
            if (selectIdsObj.prim === item.dataset.prim && selectIdsObj.ter === item.dataset.ter && selectIdsObj.sec === item.dataset.sec) {
              item.classList.remove("hidden");
            }
          }
        });
        if (secSelect.value === "All" && primSelect.value === "All" && terSelect.value === "All") {
          specTableFstRowTrs.forEach(function (tr) {
            tr.classList.remove("hidden");
          });
          tableSections.forEach(function (section) {
            section.classList.remove("hidden");
          });
        } else {
          specTableFstRowTrs.forEach(function (tr) {
            tr.classList.add("hidden");
          });
          tableSections.forEach(function (section) {
            section.classList.add("hidden");
          });
        }
        specTableTrs.forEach(function (tr) {
          specTableFstRowTrs.forEach(function (item) {
            if (item.dataset.title === tr.dataset.prim && !tr.classList.contains("hidden")) {
              item.classList.remove("hidden");
            }
          });
        });
        specTableTrs.forEach(function (tr) {
          tableSections.forEach(function (item) {
            if (item.dataset.section === tr.dataset.sec && !tr.classList.contains("hidden")) {
              item.classList.remove("hidden");
            }
          });
        });
        specTableAdopt();
      };
      initSelectFunctionality(specTable, specTableFstRow, specTableTrs, specTableFstRowTrs, selects);
      adoptSectionHeight(specTable, specTableFstRow);
      adoptSectionHeight(specTable, specTableFstRow);
    }
  })();
  window.addEventListener("resize", function () {
    customTableAdopt();
  });
});